import Swiper from 'swiper';

export default class {

    constructor() {

        let swipers = document.querySelectorAll('[data-slider]');

        if (swipers.length === 0) {
            return;
        }

        window._.forEach(swipers, this.initialise);

    }

    initialise(element) {

        let slides = element.getElementsByClassName('slide'),
            effect = element.dataset.effect,
            pagination = element.getElementsByClassName('swiper-pagination');

        if (slides.length < 2) {
            element.setAttribute('class', 'disabled');
            return;
        }

        (new Swiper(element, {

            effect: effect ? effect : 'fade',

            slideClass: 'slide',
            slideActiveClass: 'slide-active',
            slideVisibleClass: 'slide-visible',
            slideDuplicateClass: 'slide-duplicate',
            slideNextClass: 'slide-next',
            slidePrevClass: 'slide-prev',

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: pagination,
                type: 'bullets',
                clickable: true
            },

            slidesPerView: 1,
            paginationClickable: true,
            spaceBetween: 0,
            loop: true,
            speed: 2000,
            autoplay: {
                delay: 5000
            },
            autoplayDisableOnInteraction: false,

            parallax: true,
            a11y: true

        }));
    }
}


// WEBPACK FOOTER //
// ./resources/js/src/core/Slider.js